import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { TransformationSection } from './components/TransformationSection';
import { HowItWorks } from './components/HowItWorks';
import { WhatIsIncluded } from './components/WhatIsIncluded';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { UrgencyOffer } from './components/UrgencyOffer';
import { FinalCTA } from './components/FinalCTA';
export function App() {
  return <div className="min-h-screen bg-black text-white font-montserrat selection:bg-electric-blue selection:text-white overflow-x-hidden" data-id="element-0">
      <Hero data-id="element-1" />
      <PainSection data-id="element-2" />
      <TransformationSection data-id="element-3" />
      <HowItWorks data-id="element-4" />
      <WhatIsIncluded data-id="element-5" />
      <Testimonials data-id="element-6" />
      <Guarantee data-id="element-7" />
      <UrgencyOffer data-id="element-8" />
      <FinalCTA data-id="element-9" />
    </div>;
}